export default __webpack_public_path__ + "static/media/correct.95c7df90.svg";